<div [ngSwitch]="stage">
  <ng-container *ngSwitchCase="'codes'">
    <sbnb-promo-codes-edit-codes
      [promoCode]="promoCode"
      [currencies]="currencies$ | async"></sbnb-promo-codes-edit-codes>

    <div fxLayoutAlign="end center" fxLayoutGap="16px" style="margin-top: 16px">
      <sbnb-button
        [disabled]="!promoCode.codes || promoCode.codes.length === 0 || !promoCode.discount_amount"
        (click)="moveTo('restrictions')">
        Next
      </sbnb-button>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'restrictions'">
    <sbnb-promo-codes-edit-restrictions [promoCode]="promoCode"></sbnb-promo-codes-edit-restrictions>

    <div fxLayoutAlign="end center" fxLayoutGap="16px">
      <ng-template *ngTemplateOutlet="backButton"></ng-template>
      <sbnb-button (click)="checkPropertyOverlaps()">Next</sbnb-button>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'properties'">
    <h2>Applicable Properties</h2>

    <sbnb-property-selection
      [border]="true"
      [listHeight]="280"
      [selectedProperties]="promoCode.properties"
      [disabledProperties]="overlappingProperties"
      (propertiesChange)="promoCode.properties = $event.properties"></sbnb-property-selection>

    <div style="margin-top: 24px" fxLayoutAlign="end center" fxLayoutGap="12px">
      <ng-template *ngTemplateOutlet="backButton"></ng-template>
      <sbnb-button [loading]="saving" (clicked)="saveCode()">Save</sbnb-button>
    </div>
  </ng-container>
</div>

<ng-template #backButton>
  <sbnb-button type="secondary" (clicked)="goBack()">Back</sbnb-button>
</ng-template>
